<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '580px' }"
    :header="`Pesquisar Evento`"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="fluid">
      <div class="field col-12">
        <label for="name">Nome do Evento</label>
        <!--
        <InputText
          id="name"
          v-model="name"
          placeholder="Digite o nome do evento"
        />
        -->

        <AutoComplete
          v-model="selectedEvent"
          :suggestions="items"
          @complete="find"
          optionValue="id"
          optionLabel="name"
          placeholder="Digite o nome do evento"
          :dropdown="true"
        >
          <template #option="slotProps">
            <div class="flex align-options-center">
              <div>
                <b>Evento: </b> {{ slotProps.option.name }}<br />
                <b>Local:</b> {{ slotProps.option.local.name }} | <b>Status: </b
                ><span
                  :class="`badge status-${slotProps.option.status.toLowerCase()}`"
                >
                  {{ convertStatus(slotProps.option.status) }}</span
                ><br />
                <b>Data da Solicitação: </b
                >{{ $DateTime.formatarDate(slotProps.option.dtCreated) }} <br />
              </div>
            </div>
          </template>
        </AutoComplete>
      </div>
    </div>
    <template #footer>
      <Button
        label="Ver Detalhes"
        class="p-button"
        icon="pi pi-eye"
        :disabled="selectedEvent.id == null"
        @click="search()"
      />
      <Button
        label="Fechar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Event from "../../../../src/models/internal/event";

//Service
import EventService from "../../../service/internal/event/event_service";

//Convert Status
import { convertStatus } from "../../../models/enums/status_event";

export default {
  data() {
    return {
      obj: new Event(),
      service: new EventService(),
      name: null,
      items: ["Maça", "Uva", "Banana"],
      selectedEvent: {
        id: null,
        name: "",
      },
      convertStatus,
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.calendar.dialogSearch;
        return value;
      },
      set(value) {
        this.$store.state.views.calendar.dialogSearch = value;
      },
    },
  },
  methods: {
    search() {
      this.service
        .findById(this.selectedEvent.id)
        .then((data) => {
          this.obj = data;
          this.$emit("showDetails", this.obj);
        })
        .catch((error) => {
          this.$msgInfo(error);
        });
    },
    hideDialog() {
      this.obj = new Event();
      this.name = null;
      this.visibleDialog = false;
      this.selectedEvent = {
        id: null,
        name: "",
      };
    },
    find(event) {
      let isAdmin = this.$Token
        .decodeToken("access_token")
        .services.find(
          (element) => element.groupPermission === "ADMINISTRADOR_EVENTOS"
        )
        ? true
        : false;

      let listStatus = null;

      if (isAdmin) {
        listStatus = "CANCELED, SCHEDULE, FINISHED, REQUESTED";
      } else {
        listStatus = "SCHEDULE, FINISHED";
      }
      this.service
        .findByNameAndStatus(event.query, listStatus)
        .then((result) => {
          if (result.length === 0) {
            this.$toast.add({
              severity: "warn",
              summary: "Atenção.",
              detail: "Nenhum registro encontrado",
              life: 6000,
            });
          }

          this.items = result;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.fc-sticky {
  cursor: pointer;
}
</style>
